import React, { useState, useEffect } from "react";
import { useLoginCheck } from "../../hooks/useLoginCheck";

function KozSecretAudition26Page() {
  useLoginCheck();
  const [workshopData, setWorkshopData] = useState({});

  const fetchWsPatt2509RequestsData = async () => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const response = await fetch(`${apiUrl}/api/get_koz_secret_audition_26_orders/`);
      if (!response.ok) {
        throw new Error("ネットワークレスポンスが異常です。");
      }
      const data = await response.json();
      setWorkshopData(data);
    } catch (error) {
      console.error("データの取得中にエラーが発生しました:", error);
    }
  };

  useEffect(() => {
    fetchWsPatt2509RequestsData();
  }, []);

  const workshopNames = {
    "2/15-A": "2/15-レベル1",
    "2/15-B": "2/15-レベル2",
    "2/15-C": "2/15-レベル3",
    "2/22-A": "2/22-レベル1",
    "2/22-B": "2/22-レベル2",
    "2/22-C": "2/22-レベル3",
  };

  const audNames = {
    "3/28-京都": "3/28-京都",
    "3/28-兵庫": "3/28-兵庫",
    "3/29-大阪": "3/29-大阪",
  };

  const getTotalAmount = () => {
    return workshopData.total_amount || 0;
  };

  const renderWorkshopSection = (workshopKey, workshopName) => {
    const workshop = workshopData[workshopKey];
    if (!workshop || !workshop.users || workshop.users.length === 0) {
      return (
        <div key={workshopKey} className="workshop-column">
          <div className="workshop-section">
            <h3 className="workshop-title">{workshopName} (参加者: 0名)</h3>
          </div>
        </div>
      );
    }

    return (
      <div key={workshopKey} className="workshop-column">
        <div className="workshop-section">
          <h3 className="workshop-title">
            {workshopName} (参加者: {workshop.users.length}名)
          </h3>

          <ul className="customer-grid customer-header">
            <li className="cell">No</li>
            <li className="cell">名前</li>
            <li className="cell">メール</li>
            <li className="cell">電話番号</li>
          </ul>

          {workshop.users.map((user, i) => (
            <ul key={user.id} className="customer-grid">
              <li className="cell">{i + 1}</li>
              <li className="cell">{user.name}</li>
              <li className="cell">{user.email}</li>
              <li className="cell">{user.phone}</li>
            </ul>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className="ws-patt-page">
      <div className="page-container">
        <div className="total-amount-section">
          <h3 className="total-amount-title">
            合計金額: ¥{getTotalAmount().toLocaleString()}
          </h3>
          <h3 className="section-title">
            ワークショップ
          </h3>
        </div>

        <div className="workshop-grid">
          {Object.keys(workshopNames).map((workshopKey) =>
            renderWorkshopSection(workshopKey, workshopNames[workshopKey])
          )}
        </div>

        <div className="total-amount-section">
          <h3 className="section-title">
            オーディション
          </h3>
        </div>

        <div className="workshop-grid">
          {Object.keys(audNames).map((audKey) =>
            renderWorkshopSection(audKey, audNames[audKey])
          )}
        </div>
      </div>
    </div>
  );
}

export default KozSecretAudition26Page;
